import React from 'react';
import Box from '@mui/material/Box';
import Button from 'view/components/Button';
import Input from 'view/components/Input';
import FormHeader from 'view/components/Form/Header';
import { StyledFormContainer, StyledFormActions } from '../../styled';
import { QR_CODE_DONATE_PATH } from 'view/routes';
import useUser from 'hooks/user';
import { useTranslation } from 'react-i18next';
import CopyButton from 'view/components/CopyButton';
import QRCode from 'view/components/QRCode';

type ViewOBSURLProps = {
  onCancel: () => void;
};

export default function ViewQRCodeOBSURL({ onCancel }: ViewOBSURLProps) {
  const { user } = useUser();
  const { t } = useTranslation();
  const link = `${process.env.REACT_APP_UI_URL}${QR_CODE_DONATE_PATH}/${user.contentCreatorName}`;

  return (
    <StyledFormContainer>
      <FormHeader
        title={t('QR code widget for OBS')}
        description={t('Add link below to your OBS browser source')}
      />
      <Box mb={2}>
        <QRCode value={link} />
      </Box>
      <Box display="flex">
        <Input
          sx={{ mr: 2 }}
          helperText={t(
            'OBS settings for the browser source: width 128px, height 144px',
          )}
          id="OBSurl"
          type="url"
          disabled
          value={link}
        />
        <CopyButton value={link} edge="end" />
      </Box>

      <StyledFormActions>
        <Button
          label={t('Back')}
          variant="text"
          color="secondary"
          onClick={onCancel}
        />
      </StyledFormActions>
    </StyledFormContainer>
  );
}
